const s = state => state?.metaDashboard || {}

const selectors = {
  getStudents:               state => s(state).students,
  getStudentsLoading:        state => s(state).studentsLoading,
  getStudentSummary:         state => s(state).studentSummary,
  getStudentProfile:              state => s(state).studentProfile,
  getStudentProfileLoading:       state => s(state).studentProfileLoading,
  getStudentAssessments:          state => s(state).studentAssessments,
  getStudentAssessmentsLoading:   state => s(state).studentAssessmentsLoading,

  getCorporateSummary:       state => s(state).corporateSummary,
  getCorporateGlobalSummary: state => s(state).corporateGlobalSummary,
  getCorporateDepartments:   state => s(state).corporateDepartments,
  getCorporateDepartmentsTable:        state => s(state).corporateDepartmentsTable,
  getCorporateDepartmentsTableLoading: state => s(state).corporateDepartmentsTableLoading,
  getCorporateShortlist:     state => s(state).corporateShortlist,
  getCorporateShortlistTable:        state => s(state).corporateShortlistTable,
  getCorporateShortlistTableLoading: state => s(state).corporateShortlistTableLoading,
  getCorporateLoading:       state => s(state).corporateLoading,
  getCorporateCampusQuality:      state => s(state).corporateCampusQuality,
  getCorporateCampusQualityTable:        state => s(state).corporateCampusQualityTable,
  getCorporateCampusQualityTableLoading: state => s(state).corporateCampusQualityTableLoading,
  getCorporatePlacementSummary:   state => s(state).corporatePlacementSummary,
  getCorporateCompanies:          state => s(state).corporateCompanies,
  getCorporateCompaniesLoading:   state => s(state).corporateCompaniesLoading,

  getInstitutes:             state => s(state).institutes,
  getInstitutesLoading:      state => s(state).institutesLoading,
  getInstituteSummary:       state => s(state).instituteSummary,
  getInstituteSummaryLoading:     state => s(state).instituteSummaryLoading,
  getInstitutePlacement:          state => s(state).institutePlacement,
  getInstitutePlacementLoading:   state => s(state).institutePlacementLoading,

  getFilterDepartments:      state => s(state).filterDepartments,
  getFilterStates:           state => s(state).filterStates,
  getFilterDegrees:          state => s(state).filterDegrees,
  getFilterColleges:         state => s(state).filterColleges,
  getFilterSkills:           state => s(state).filterSkills,
  getFilterCities:           state => s(state).filterCities,
}

export default selectors
